import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M15 11h-5v5H9v-5H4v-1h5V5h1v5h5v1zM9.5 2c4.687 0 8.5 3.813 8.5 8.5S14.187 19 9.5 19 1 15.187 1 10.5 4.813 2 9.5 2zm0-1C4.275 1 0 5.275 0 10.5S4.275 20 9.5 20s9.5-4.275 9.5-9.5S14.725 1 9.5 1z',
  ],
  height: 20,
  width: 20,
});
